<template>
  <div class="shipping-block">
    <h3 class="step__block-title">Billing:</h3>

    <div class="step__block-fields">
      <div class="step__block-container">
        <span class="step__block-container-left">Address:</span>
        <input
          type="text"
          v-model="estimate.client.billingAddress"
          placeholder="NY, Boynton Avenue, 1145"
          autocomplete="new-password"
        />
      </div>

      <div class="step__block-container">
        <span class="step__block-container-left label-required">ZIP:</span>
        <ShippingZipCode
          v-model:zip="estimate.client.billingZip"
          v-model:state="estimate.client.billingState"
          type="billing"
        />
      </div>

      <div class="step__block-container">
        <span class="step__block-container-left label-required">State:</span>
        <ShippingStatesSelect v-model:state="estimate.client.billingState" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

import { ShippingZipCode, ShippingStatesSelect } from "@/modules/shipping";

const estimateStore = useNewEstimateStore();
const estimate = computed(() => estimateStore.estimate);
</script>

<style scoped>
.shipping-block {
  margin-block: 12px;
}

.step__block-container {
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: grid;
  grid-template-columns: 40% 60%;
  column-gap: 10px;
}

.step__block-fields {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.step__block .step__block-container-left {
  align-self: center;
}

.step__block--data .step__block-container input,
.step__block-wrapper .step__block-container input {
  padding: 9px 20px;
  background-color: #fff;
  border-radius: 25px;
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step__block-title {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

  padding-block: 12px;
  margin-bottom: 16px;

  border-top: 1px solid #e6e9f0;
  border-bottom: 1px solid #e6e9f0;
}
</style>
